<template>
  <FormContainer class="register__sent-confirmation-letter-form__form-container">
    <div class="sent-confirmation-letter-form__text-block">
      <h2 class="sent-confirmation-letter-form__title">Вітаю в UConnect</h2>
      <p class="sent-confirmation-letter-form__description">Ми надійна CRM-платформа для агентів і партнерських мереж</p>
    </div>
    <StatusProgress
      class="sent-confirmation-letter-form__progress"
      :current-step="getCurrentStep"
    />
    <p class="sent-confirmation-letter__text">
      Ми надіслали лист із посиланням для підтвердження на адресу {{ getAccountEmail }}.
      Перейдіть за посиланням, щоб завершити реєстрацію.
      <span
        v-if="sendDelay !== null"
        class="sent-confirmation-letter__resend--timer"
      >
        Відправити ще раз можна буде через {{ getExpirationText(sendDelay, getSecondsExpirationForms) }}
      </span>
    </p>
    <div class="sent-confirmation-letter__resend">
      <OrangeFancyButton
        class="sent-confirmation-letter__resend--button"
        :disabled="sendDelay !== null || isResendVerificationLoading"
        @click="resentValidationLink"
      >
        <SpinnerLoader
          v-show="isResendVerificationLoading"
          class="sent-confirmation-letter__controls--loader"
          color="#FFFFFF"
        />
        Надіслати ще раз
      </OrangeFancyButton>
      <p class="sent-confirmation-letter__error-message" v-if="getResendVerificationError">{{ getResendVerificationError }}</p>
      <a
        class="sent-confirmation-letter__prev-step--button"
        @click="switchPreviousStep"
      >
        Назад
      </a>
    </div>
    <div class="sent-confirmation-letter__login">
      <p class="sent-confirmation-letter__login-text">
        У вас вже є аккаунт?
        <SmartLink
          class="sent-confirmation-letter__link--login"
          :route="{ name: 'login' }"
        >
          Увійти
        </SmartLink>
      </p>
    </div>
  </FormContainer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import StatusProgress from '../status-progress';
import { secondsForms } from '@/shared/config/expiration-forms';
import { expirationText } from '@/shared/lib/string';
import { FormContainer } from '@/shared/ui/account';
import { OrangeFancyButton } from '@/shared/ui/form';
import { SmartLink } from '@/shared/ui/link';
import { SpinnerLoader } from '@/shared/ui/loader';

export default {
  data() {
    return {
      delayTimer: null,
      sendDelay: null,
    };
  },
  async mounted() {
    this.sendDelay = await this.getTimeUntilNextVerifyRequest();
    this.runDelayTimer();
  },
  mixins: [ expirationText ],
  components: { SpinnerLoader, StatusProgress, FormContainer, SmartLink, OrangeFancyButton },
  computed: {
    ...mapGetters('registerModule', [
      'getCurrentStep', 'getAccountEmail', 'isResendVerificationLoading', 'getResendVerificationError'
    ]),
    getSecondsExpirationForms() {
      return secondsForms.forms;
    },
  },
  methods: {
    ...mapActions('registerModule', ['switchPreviousStep', 'getTimeUntilNextVerifyRequest', 'resendVerificationEmail']),
    runDelayTimer() {
      this.delayTimer = setInterval(() => {
        if (this.sendDelay > 1) {
          this.sendDelay--;
        } else {
          clearInterval(this.delayTimer);
          this.sendDelay = null;
          this.delayTimer = null;
        }
      }, 1000);
    },
    async resentValidationLink() {
      await this.resendVerificationEmail();
      this.sendDelay = await this.getTimeUntilNextVerifyRequest();
      this.runDelayTimer();
    },
  },
};
</script>

<style lang="scss" scoped>
.register__sent-confirmation-letter-form {
  &__form-container {
    margin: 170px auto 0;
    width: 600px;

    @media (max-width: 630px) {
      margin: 50px 16px 0;
      width: auto;
    }
  }
}

.sent-confirmation-letter-form {
  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 36px;
    font-weight: 400;
    color: #0C1421;
    text-align: center;
    margin-bottom: 16px;

    @media (max-width: 630px) {
      font-size: 24px;
    }
  }

  &__description {
    font-size: 18px;
    font-weight: 400;
    color: #313957;
    text-align: center;

    @media (max-width: 630px) {
      font-size: 14px;
    }
  }

  &__progress {
    margin-bottom: 16px;
  }
}

.sent-confirmation-letter {
  &__text {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #313957;
    margin-bottom: 32px;
  }

  &__next-step {
    margin-bottom: 32px;
  }

  &__prev-step {
    &--button {
      display: inline-block;
      font-family: 'Inter', sans-serif;
      font-size: 16px;
      font-weight: 400;
      color: #313957;
      padding: 16px 24px;
      width: 100%;
      text-align: center;
      cursor: pointer;
    }
  }

  &__resend--timer {
    color: #6171E4;
  }

  &__login {
    text-align: center;
  }

  &__link {
    &--login {
      font-family: 'Inter', sans-serif;
      font-size: 16px;
      font-weight: 400;
      color: #6171E4;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  &__controls {
    &--loader {
      margin-right: 12px;
    }
  }

  &__error-message {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #FF3B30;
    margin-top: 16px;
  }
}

::v-deep .orange-fancy-button__content {
  display: flex;
  justify-content: center;
}
</style>
